import type { PartialWithFieldValue } from 'firebase/firestore'
import {
  collectionGroup,
  query,
  where,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import type { StreamInterface } from 'tricklejs/dist/types'
import { modelListStream } from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import type { FirestoreRoomStateOutput } from './schema'
import { schema, writeSchema } from './schema'
import { RoomStateOutput } from '../../models/RoomStateOutput'

const converter: FirestoreDataConverter<FirestoreRoomStateOutput> = {
  toFirestore: (data: PartialWithFieldValue<FirestoreRoomStateOutput>) => {
    writeSchema.partial().parse(data)
    return data
  },
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

export const getSectionRoomStateOutputs = (
  repository: FirebaseRepository,
  params: { sectionId: string }
): StreamInterface<RoomStateOutput[]> => {
  const ref = collectionGroup(
    repository.firestore,
    'room_state_output'
  ).withConverter(converter)

  const q = query(ref, where('sectionId', '==', params.sectionId))
  return modelListStream(repository, q, RoomStateOutput)
}
